import styled from 'styled-components';

const sliceGap = 28;
const halfGap = sliceGap / 2;
const sliceGapMobile = 16;
const halfGapMobile = sliceGapMobile / 2;

export const CustomCarouselContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['dotsWidth'].includes(prop),
})`
  .slick-slider {
    .slick-list {
      padding-bottom: 10px !important;
      display: flex;
      .slick-track {
        margin: 0;
        display: flex !important;
        height: auto;
        align-items: center;
      }
    }

    .slick-slide {
      min-height: inherit !important;
      > div {
        height: inherit !important;
      }
    }
    .slick-dots {
      bottom: -50px !important;
      width: fit-content;
      left: ${({ dotsWidth }) =>
        `calc(50% - ${dotsWidth / 2}px - ${halfGap}px)`};

      li {
        & button::before {
          content: '';
          opacity: 1;
          border: 2px solid ${({ theme }) => theme.colors.focusSelect} !important;
          color: ${({ theme }) => theme.colors.focusSelect} !important;
          width: 12px;
          height: 12px;
          border-radius: 100%;
          margin-top: 2px;
          background-color: transparent;
        }
      }
      li.slick-active {
        & button::before {
          background-color: ${({ theme }) =>
            theme.colors.focusSelect} !important;
          width: 16px;
          height: 16px;
          margin-top: 0;
        }
      }
    }

    .slick-next,
    .slick-prev {
      position: absolute;
      top: calc(100% + 35px);
      z-index: ${(props) => props.theme.zIndex.box};
      &.slick-disabled svg {
        stroke: ${(props) => props.theme.colors.disabled} !important;
      }

      &:hover,
      &:active,
      &:focus {
        color: none;
        outline: none;
      }

      &::before {
        display: none;
      }
    }

    .slick-prev {
      left: calc(
        50% - 12.5px - ${({ dotsWidth }) => dotsWidth / 2}px - 40px -
          ${halfGap}px
      );
    }
    .slick-next {
      right: calc(
        50% - ${({ dotsWidth }) => dotsWidth / 2}px - 40px + ${halfGap}px
      );
    }

    @media ${(props) => props.theme.device.tablet} {
      .slick-dots {
        left: ${({ dotsWidth }) => `calc(50% - ${dotsWidth / 2}px + 3px)`};
      }

      .slick-prev {
        width: 25px;
        left: calc(
          50% - ${({ dotsWidth }) => dotsWidth / 2}px - ${sliceGapMobile}px +
            3px - 25px
        );
      }
      .slick-next {
        width: 25px;
        right: calc(
          50% - ${({ dotsWidth }) => dotsWidth / 2}px - ${sliceGapMobile}px +
            3px - 25px
        );
      }
    }
  }
`;

// this component is not in index.jsx bat can be used to wrap CustomCarouselContainer
export const CarouselWrapper = styled.div`
  padding-bottom: 80px;
  width: calc(100% + ${sliceGap}px);

  .slick-list {
    margin-left: -${halfGap}px;
  }

  .slick-slide {
    margin: 0 ${halfGap}px;
  }

  @media ${(props) => props.theme.device.tabletL} {
    width: auto;
  }

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
    .slick-list {
      margin-left: 0;
    }
    .slick-slide {
      margin: 0 ${halfGapMobile}px;
    }
  }
`;
